module.exports = __webpack_public_path__ + "static/img/background-404.8b30fb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background-404.jpg
// module id = 9xb7
// module chunks = 22 24